import styled from 'styled-components';

interface ISignatureCaptionProps {
  isLarge: boolean;
}

export const SignatureBox = styled('div')`
  width: 3.5cm;
  height: 4.7cm;
  margin: 0.15cm;
  display: flex;
  border: 1px solid #dcdcdc;
  flex-direction: column;
  justify-content: flex-end;
`;

export const SignatureImage = styled('img')`
  width: 3cm;
  height: 3cm;
  margin: auto;
`;

export const WithoutSignature = styled('span')`
  height: 3.5cm;
  display: inline-flex;
  padding: 0 0.5rem;
  font-size: 12px;
  text-align: center;
  line-height: 1.75;
  align-items: center;
  justify-content: center;
`;

export const SignatureOwnerName = styled('span')<ISignatureCaptionProps>`
  height: 0.7cm;
  display: inline-flex;
  font-size: ${(props) => (props.isLarge ? '10px' : '13px')};
  align-items: center;
  font-weight: 400;
  justify-content: center;
  background-color: #e2e5e7;
  text-align: center;
  & span {
    margin: ${(props) => (props.isLarge ? '2px' : '0')};
    overflow: hidden;
    word-break: break-word;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
`;

export const SignatureOwnerRole = styled('span')<ISignatureCaptionProps>`
  //height: 0.5cm;
  display: inline-flex;
  text-align: center;
  font-size: ${(props) => (props.isLarge ? '9px' : '11px')};
  align-items: center;
  font-weight: 400;
  justify-content: center;
  & span {
    margin: ${(props) => (props.isLarge ? '2px' : '0')};
    overflow: hidden;
    word-break: break-word;
    white-space: pre-wrap;
    //text-overflow: ellipsis;
  }
`;

export const SignaturesTable = styled('table')`
  width: 100%;
  margin: 0.5rem 0;
  border-collapse: collapse;

  & tbody {
    border: 2px solid #747474;
    & tr {
      & td {
        width: 4cm;
        padding: 0;
        height: 4.7cm;
      }
    }
  }

  & thead {
    border: 2px solid #747474;
    & tr {
      & th {
        color: 'var(--exact-white)';
        width: 100%;
        height: 2.3rem;
        padding: 0;
        font-size: 1rem;
        text-align: center;
        background: #747474;
        font-weight: 500;
      }
    }
  }
`;
